// Which version of the page this is, and which version of the API contract it speaks.
//
// BUILD is the commit (or "dev"): it says whether a newer page exists. LEVEL is a whole number that goes up ONLY when the API can no longer serve
// the previous page at all. The server keeps a minimum level; a page below it is told "client_outdated", reloads itself, and keeps its queue. The
// rule is expand-then-contract (docs/api-compat.md): a field a page from the last 30 days uses is never removed or renamed, so LEVEL rarely moves.
export const BUILD: string = typeof __BUILD_ID__ === 'string' ? __BUILD_ID__ : 'dev'
export const CLIENT_LEVEL = 1
export const LEVEL_HEADER = 'x-kwento-level'
export const BUILD_HEADER = 'x-kwento-build'
